import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { AREA_CAPABILITIES } from '../areaCapabilities';
import {
  InventoryDashboard,
  InventoryMobileHub,
  InventoryMobileAddItem,
  InventoryItemForm,
  InventoryItemDetail,
  InventoryParameters,
  VendorManager,
  KitManager,
  RequisitionList,
  RequisitionForm,
  RequisitionDetail,
  PurchaseOrderList,
  PurchaseOrderForm,
  PurchaseOrderDetail,
  ProcurementApprovalInbox,
} from '../lazyComponents';

/** Inventory and supply chain (requisitions, POs). */
export function InventoryProcurementRoutes({ withCapability }) {
  return (
    <>
      <Route path="/inventory-field" element={withCapability(AREA_CAPABILITIES.inventory, <Navigate to="/inventory/mobile" replace />)} />
      <Route path="/inventory" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryDashboard />)} />
      <Route path="/inventory/mobile/new" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryMobileAddItem />)} />
      <Route path="/inventory/mobile" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryMobileHub />)} />
      <Route path="/inventory/new" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryItemForm />)} />
      <Route path="/inventory/:id" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryItemDetail />)} />
      <Route path="/inventory/:id/edit" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryItemForm />)} />
      <Route path="/inventory/parameters" element={withCapability(AREA_CAPABILITIES.inventory, <InventoryParameters />)} />
      <Route path="/inventory/vendors" element={withCapability(AREA_CAPABILITIES.inventory, <VendorManager />)} />
      <Route path="/inventory/kits" element={withCapability(AREA_CAPABILITIES.inventory, <KitManager />)} />

      <Route path="/supply-chain/requisitions" element={withCapability(AREA_CAPABILITIES.procurement, <RequisitionList />)} />
      <Route path="/supply-chain/requisitions/new" element={withCapability(AREA_CAPABILITIES.procurement, <RequisitionForm />)} />
      <Route path="/supply-chain/requisitions/:id" element={withCapability(AREA_CAPABILITIES.procurement, <RequisitionDetail />)} />
      <Route path="/supply-chain/requisitions/:id/edit" element={withCapability(AREA_CAPABILITIES.procurement, <RequisitionForm />)} />
      <Route path="/supply-chain/purchase-orders" element={withCapability(AREA_CAPABILITIES.procurement, <PurchaseOrderList />)} />
      <Route path="/supply-chain/purchase-orders/new" element={withCapability(AREA_CAPABILITIES.procurement, <PurchaseOrderForm />)} />
      <Route path="/supply-chain/purchase-orders/:id" element={withCapability(AREA_CAPABILITIES.procurement, <PurchaseOrderDetail />)} />
      <Route path="/supply-chain/purchase-orders/:id/edit" element={withCapability(AREA_CAPABILITIES.procurement, <PurchaseOrderForm />)} />
      <Route path="/supply-chain/approval-inbox" element={withCapability(AREA_CAPABILITIES.procurement, <ProcurementApprovalInbox />)} />
      <Route path="/supply-chain/vendors" element={withCapability(AREA_CAPABILITIES.procurement, <VendorManager />)} />
    </>
  );
}
